import styled from 'styled-components';
import { BaseConfetti } from 'elements/confetti/confetti.styles';
import { layout } from 'styles/layout';
import React from 'react';

export const ConfettiContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 600px;
  max-height: initial;

`

export const ConfettiElement1 = styled(BaseConfetti).attrs({
  width: 36,
  height: 41,
  viewBox: '0 0 36 41',
  children: <path d="M0.99981 39.827L34.5187 23.7185L31.9735 6.47681L21.6992 1L0.99981 39.827Z" stroke="#F1B6B0" strokeWidth="2" strokeLinejoin="round" />
})`
  display: none;

  @media screen and (min-width: ${layout.subLg}) {
    display: block;
    width: 27px;
    top: 0;
    left: 0;
  }
`

export const ConfettiElement2 = styled(BaseConfetti).attrs({
  width: 253,
  height: 254,
  viewBox: '0 0 253 254',
  children: <>
    <linearGradient id="confetti_element_2_gradient_1_" gradientUnits="userSpaceOnUse" x1="53.146" y1="-763.8314" x2="228.5709" y2="-838.6312" gradientTransform="matrix(1 0 0 -1 -2.651524e-06 -638)">
      <stop offset="0" stopColor="#E7B556" />
      <stop offset="1" stopColor="#F1B6B0" />
    </linearGradient>
    <path fill="none" stroke="url(#confetti_element_2_gradient_1_)" strokeWidth="1.2" d="M106.7,0L0,251l250-100.4L216.4,46.7L106.7,0z" />
    <linearGradient xmlns="http://www.w3.org/2000/svg" id="confetti_element_2_gradient_2_" gradientUnits="userSpaceOnUse" x1="65.4194" y1="-759.2134" x2="216.9452" y2="-823.8222" gradientTransform="matrix(1 0 0 -1 -2.651524e-06 -638)">
      <stop offset="0" stopColor="#E7B556" />
      <stop offset="1" stopColor="#F1B6B0" />
    </linearGradient>
    <path fill="none" stroke="url(#confetti_element_2_gradient_2_)" strokeWidth="1.2" d="M111.8,12.3L19.5,229.4l216-87l-29-89.3L111.8,12.3z" />
    <linearGradient id="confetti_element_2_gradient_3_" gradientUnits="userSpaceOnUse" x1="78.0032" y1="-756.8384" x2="206.5477" y2="-811.6487" gradientTransform="matrix(1 0 0 -1 -2.651524e-06 -638)">
      <stop offset="0" stopColor="#E7B556" />
      <stop offset="1" stopColor="#F1B6B0" />
    </linearGradient>
    <path fill="none" stroke="url(#confetti_element_2_gradient_3_)" strokeWidth="1.2" d="M117.5,26L38.7,210.8l183.8-74.5l-24.2-75.8L117.5,26z" />
    <linearGradient id="confetti_element_2_gradient_4_" gradientUnits="userSpaceOnUse" x1="90.5878" y1="-754.4543" x2="197.9898" y2="-800.2494" gradientTransform="matrix(1 0 0 -1 -2.651524e-06 -638)">
      <stop offset="0" stopColor="#E7B556" />
      <stop offset="1" stopColor="#F1B6B0" />
    </linearGradient>
    <path fill="none" stroke="url(#confetti_element_2_gradient_4_)" strokeWidth="1.2" d="M123.2,39.7L58.2,192.3l153.1-61l-20.4-62.8L123.2,39.7z" />
    <linearGradient id="confetti_element_2_gradient_5_" gradientUnits="userSpaceOnUse" x1="101.1503" y1="-751.8718" x2="185.5728" y2="-787.8684" gradientTransform="matrix(1 0 0 -1 -2.651524e-06 -638)">
      <stop offset="0" stopColor="#E7B556" />
      <stop offset="1" stopColor="#F1B6B0" />
    </linearGradient>
    <path fill="none" stroke="url(#confetti_element_2_gradient_5_)" strokeWidth="1.2" d="M127.1,52.8L76.2,174.5l119.5-48.2L180.1,76L127.1,52.8z" />
    <linearGradient id="confetti_element_2_gradient_6_" gradientUnits="userSpaceOnUse" x1="113.7335" y1="-749.4974" x2="176.0944" y2="-776.0871" gradientTransform="matrix(1 0 0 -1 -2.651524e-06 -638)">
      <stop offset="0" stopColor="#E7B556" />
      <stop offset="1" stopColor="#F1B6B0" />
    </linearGradient>
    <path fill="none" stroke="url(#confetti_element_2_gradient_6_)" strokeWidth="1.2" d="M132.8,66.5l-37.5,89.4l88.5-35.8l-11.7-36.8L132.8,66.5z" />
    <linearGradient id="confetti_element_2_gradient_7_" gradientUnits="userSpaceOnUse" x1="125.3836" y1="-746.7654" x2="165.6828" y2="-763.9485" gradientTransform="matrix(1 0 0 -1 -2.651524e-06 -638)">
      <stop offset="0" stopColor="#E7B556" />
      <stop offset="1" stopColor="#F1B6B0" />
    </linearGradient>
    <path fill="none" stroke="url(#confetti_element_2_gradient_7_)" strokeWidth="1.2" d="M137.6,79.9L115,137.6l55.4-22.5l-8.2-24.7L137.6,79.9z" />
    <linearGradient id="confetti_element_2_gradient_8_" gradientUnits="userSpaceOnUse" x1="138.0066" y1="-744.428" x2="156.2525" y2="-752.208" gradientTransform="matrix(1 0 0 -1 -2.651524e-06 -638)">
      <stop offset="0" stopColor="#E7B556" />
      <stop offset="1" stopColor="#F1B6B0" />
    </linearGradient>
    <path fill="none" stroke="url(#confetti_element_2_gradient_8_)" strokeWidth="1.2" d="M143.8,92.7l-11.4,26.7l26.3-10.8l-3.4-10.9L143.8,92.7z" />
  </>
})`
  width: 40%;
  top: 0%;
  left: 26%;
  transform: rotate(0deg) scale(1.5);

  @media all and (max-width: 1100px) {
    top: calc((10vw - 110px) * 2);
  }

  @media screen and (max-width: 800px) {
    top: -44px;
    left: -10%;
    transform: rotate(255deg) scale(1);
  }

`

export const ConfettiElement3 = styled(BaseConfetti).attrs({
  width: 351.5,
  height: 376.7,
  viewBox: '0 0 351.5 376.7',
  children: <>
    <g opacity="0.5">
      <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="40.3073" y1="-559.5186" x2="319.0923" y2="-934.176" gradientTransform="matrix(1 0 0 -1 0 -560)">
        <stop offset="0.6198" stopColor="#963481" />
        <stop offset="1" stopColor="#1CABBF" />
      </linearGradient>
      <path stroke="url(#SVGID_1_)" strokeWidth="2" strokeLinejoin="round" d="M38.3,1L1,203l104.1,139.8l212,32.8   l33.4-215.5L252.4,28.2L38.3,1z" />
      <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="53.0132" y1="-576.8881" x2="305.5312" y2="-916.246" gradientTransform="matrix(1 0 0 -1 0 -560)">
        <stop offset="0.6198" stopColor="#963481" />
        <stop offset="1" stopColor="#1CABBF" />
      </linearGradient>
      <path stroke="url(#SVGID_2_)" strokeWidth="2" strokeLinejoin="round" d="M51.2,18.2L18.3,200.5l94.2,126.7   l191.2,30.4L333.2,163L244.2,43.5L51.2,18.2z" />
      <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="66.9022" y1="-595.0361" x2="293.1532" y2="-899.0941" gradientTransform="matrix(1 0 0 -1 0 -560)">
        <stop offset="0.6198" stopColor="#963481" />
        <stop offset="1" stopColor="#1CABBF" />
      </linearGradient>
      <path stroke="url(#SVGID_3_)" strokeWidth="2" strokeLinejoin="round" d="M65.3,36.2L36.7,198.9l84.4,113.5   l170.4,27.9l25.4-173.6L237.3,59.6L65.3,36.2z" />
      <linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="80.9899" y1="-614.1633" x2="277.3929" y2="-878.1083" gradientTransform="matrix(1 0 0 -1 0 -560)">
        <stop offset="0.6198" stopColor="#963481" />
        <stop offset="1" stopColor="#1CABBF" />
      </linearGradient>
      <path stroke="url(#SVGID_4_)" strokeWidth="2" strokeLinejoin="round" d="M79.6,55.2L54.3,196.7l73.3,98.5L276,319.1   l22.5-151l-69.2-92.9L79.6,55.2z" />
      <linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="96.2579" y1="-634.0693" x2="263.4099" y2="-858.7033" gradientTransform="matrix(1 0 0 -1 0 -560)">
        <stop offset="0.6198" stopColor="#963481" />
        <stop offset="1" stopColor="#1CABBF" />
      </linearGradient>
      <path stroke="url(#SVGID_5_)" strokeWidth="2" strokeLinejoin="round" d="M95.1,75L73.3,195.6l62.4,83.8l126.6,20.1   l19.5-128.8l-58.9-79.1L95.1,75z" />
      <linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="111.3283" y1="-655.254" x2="247.4373" y2="-838.17" gradientTransform="matrix(1 0 0 -1 0 -560)">
        <stop offset="0.6198" stopColor="#963481" />
        <stop offset="1" stopColor="#1CABBF" />
      </linearGradient>
      <path stroke="url(#SVGID_6_)" strokeWidth="2" strokeLinejoin="round" d="M110.4,96l-18.5,98.8l50.8,68.3l103.8,15.9   L263,173.5l-47.9-64.4L110.4,96z" />

      <linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="126.5961" y1="-675.1602" x2="233.4541" y2="-818.7662" gradientTransform="matrix(1 0 0 -1 0 -560)">
        <stop offset="0.6198" stopColor="#963481" />
        <stop offset="1" stopColor="#1CABBF" />
      </linearGradient>
      <path stroke="url(#SVGID_7_)" strokeWidth="2" strokeLinejoin="round" d="M125.8,115.7l-15,77.9l39.9,53.6l82,12.1   l13.5-83.1l-37.6-50.6L125.8,115.7z" />

      <linearGradient id="SVGID_8_" gradientUnits="userSpaceOnUse" x1="139.302" y1="-692.5302" x2="219.893" y2="-800.8353" gradientTransform="matrix(1 0 0 -1 0 -560)">
        <stop offset="0.6198" stopColor="#963481" />
        <stop offset="1" stopColor="#1CABBF" />
      </linearGradient>
      <path stroke="url(#SVGID_8_)" strokeWidth="2" strokeLinejoin="round" d="M138.7,133l-10.6,58.3l30.1,40.4l61.1,9.6   l9.5-62.2L200.4,141L138.7,133z" />

      <linearGradient id="SVGID_9_" gradientUnits="userSpaceOnUse" x1="153.7819" y1="-711.7303" x2="206.3159" y2="-782.3303" gradientTransform="matrix(1 0 0 -1 0 -560)">
        <stop offset="0.6198" stopColor="#963481" />
        <stop offset="1" stopColor="#1CABBF" />
      </linearGradient>
      <path stroke="url(#SVGID_9_)" strokeWidth="2" strokeLinejoin="round" d="M154.2,151.5l38.2,4.4l19.6,26.4l-5.3,39.9   l-40.4-5.8l-18.5-24.9L154.2,151.5z" />

      <linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="166.7445" y1="-729.9316" x2="191.8174" y2="-763.6266" gradientTransform="matrix(1 0 0 -1 0 -560)">
        <stop offset="0.6198" stopColor="#963481" />
        <stop offset="1" stopColor="#1CABBF" />
      </linearGradient>
      <path stroke="url(#SVGID_10_)" strokeWidth="2" strokeLinejoin="round" d="M166.9,169.8l17.8,2.5l9.4,12.6l-2.1,18.7   l-18.8-3.1l-8.8-11.9L166.9,169.8z" />
    </g>
  </>
})`
  width: 59%;
  top: 42%;
  left: -2%;
  right: initial;

  @media screen and (max-width: 1158px) {
    top: calc(177px + (10vw - 116px) * 3.5);
  }
  @media screen and (max-width: 800px) {
    top: 58px;
    left: initial;
    right: -8%;
  }
`

export const ConfettiElement4 = styled(BaseConfetti).attrs({
  width: 28,
  height: 26,
  viewBox: '0 0 28 26',
  children: <path d="M2.02438 2.34875L25.4731 22.8871L3.54007 24.3953L2.02438 2.34875Z" stroke="#89026C" strokeWidth="2" strokeLinejoin="round" />
})`
  width: 24px;
  left: 208%;
  top: initial;
  bottom: 0;

  @media all and (max-width: 1282px) {
    left: calc(1170px - (1282px - 100vw));
    bottom: calc((100vw - 1282px) / 10);
  }
  @media all and(max-width: 800px) {
    display: none;
  }
`

export const ConfettiElement5 = styled(BaseConfetti).attrs({
  width: 30,
  height: 27,
  viewBox: '0 0 30 27',
  children: <path d="M17.2346 1.52391L1.1783 4.58166L4.38045 20.6098L12.1816 25.8637L28.1512 22.7475L25.0357 6.77786L17.2346 1.52391Z" stroke="#E7B556" strokeWidth="2" strokeLinejoin="round" />
})`
  display: block;
  width: 23px;
  left: 200%;
  bottom: -55px;

  @media all and (max-width: 1282px) {
    left: calc(1140px - (1282px - 100vw));
    bottom: calc(((100vw - 1282px) / 10) - 55px);
  }
  @media all and(max-width: 800px) {
    display: none;
  }
`
